//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    body: String,
    title: String,
    imageUrl: String,
    caption: String,
    link: String
  }
}
